export default {
  path: '/solution-edit',
  auth: true,
  preload: false,
  key: 'solution-edit',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
